import { useState } from 'react';
import { X } from 'lucide-react';

const Products = () => {
    const [activeFilter, setActiveFilter] = useState('all');
    const [selectedProduct, setSelectedProduct] = useState(null);

    const products = [
        // Industrial Furnaces
        {
            id: 'annealing-furnace',
            name: 'Pit Type Annealing Furnace',
            category: 'Industrial Furnace',
            type: 'annealing',
            image: '/paf2.jpeg',
            description: 'High-precision annealing furnace suitable for annealing, tempering, stress relieving, normalising, and spheroidizing processes.',
            specs: [
                { label: 'Capacity Range', value: '250 KGS TO 3 TONS' },
                { label: 'Power Rating', value: '36 KWS TO 150 KWS' },
                { label: 'Power Source', value: 'Electric / Gas' },
                { label: 'Applications', value: 'Annealing, Tempering, Stress Relieving, Normalising, Spheroidizing' },
            ],
        },
        {
            id: 'bogie-hearth',
            name: 'Bogie Hearth Furnace',
            category: 'Industrial Furnace',
            type: 'other',
            image: '/bhf.jpeg',
            description: 'Well-suited for mass production with excellent PLC control over furnace processes and work quality.',
            specs: [
                { label: 'Capacity Range', value: '500 KGS TO 2 TONS' },
                { label: 'Power Rating', value: '54 KWS TO 150 KWS' },
                { label: 'Power Source', value: 'Electric / Gas' },
                { label: 'Applications', value: 'Hardening, Annealing, Tempering, Stress Relieving, Normalizing' },
                { label: 'Control System', value: 'PLC Based' },
            ],
        },
        {
            id: 'chamber-furnace',
            name: 'Chamber Type Furnace',
            category: 'Industrial Furnace',
            type: 'other',
            image: '/cf.jpeg',
            description: 'Enclosed, insulated space designed for uniform heating and processing of materials at controlled temperatures.',
            specs: [
                { label: 'Type', value: 'Chamber Type' },
                { label: 'Features', value: 'Uniform heating, Controlled temperature, Enclosed & insulated' },
            ],
        },
        {
            id: 'continuous-hardening',
            name: 'Continuous Mesh Belt Hardening Furnace',
            category: 'Continuous Furnace',
            type: 'continuous',
            image: '/continous_mesh_belt_roller_type.jpeg',
            description: 'High-throughput continuous hardening line for various heat treatment processes.',
            specs: [
                { label: 'Model Range', value: 'ARKO-CMH-50 to ARKO-CMH-500' },
                { label: 'Capacity Range', value: '50 KGS TO 500 KGS' },
                { label: 'Power Rating', value: '50 KWS TO 180 KWS' },
                { label: 'Power Source', value: 'Electric' },
                { label: 'Applications', value: 'Hardening, Carburizing, Annealing, Tempering, Austempering, Stress Relieving, Sintering' },
                { label: 'Atmosphere', value: 'Reducing or Inert Gas' },
                { label: 'Industries', value: 'Bearings, Chains, Auto Parts, Bicycle Parts, Hand Tools, Springs, Fasteners' },
            ],
        },
        {
            id: 'continuous-tempering',
            name: 'Continuous Mesh Belt Tempering Furnace',
            category: 'Continuous Furnace',
            type: 'continuous',
            image: '/cmbf2.jpeg',
            description: 'Industrial continuous tempering furnace for high-volume production.',
            specs: [
                { label: 'Model Range', value: 'ARKO-CMT-50 to ARKO-CMT-500' },
                { label: 'Capacity Range', value: '50 KGS TO 500 KGS' },
                { label: 'Power Rating', value: '30 KWS TO 120 KWS' },
                { label: 'Power Source', value: 'Electric' },
                { label: 'Industries', value: 'Bearings, Chains, Auto Parts, Hand Tools, Springs, Fasteners, Surgical Tools' },
            ],
        },
        {
            id: 'gas-carburizing',
            name: 'Pit Type Gas Carburizing Furnace',
            category: 'Industrial Furnace',
            type: 'other',
            image: '/gcf.jpeg',
            description: 'Pit-type furnace equipped with internal retorts, completely sealed for high-capacity batch operations.',
            specs: [
                { label: 'Capacity Range', value: '100 KGS TO 2 TONS' },
                { label: 'Power Rating', value: '36 KWS TO 150 KWS' },
                { label: 'Power Source', value: 'Electric / Gas' },
                { label: 'Type', value: 'Batch-type, Manual Operation' },
                { label: 'Applications', value: 'Hardening, Carburizing, Annealing, Tempering, Carbonitriding, Normalising' },
                { label: 'Features', value: 'Internal retorts, Completely sealed, Minimal installation space' },
            ],
        },
        {
            id: 'rotary-retort',
            name: 'Rotary Retort Furnace',
            category: 'Retort Furnace',
            type: 'retort',
            image: '/rrf5.jpeg',
            description: 'Complete heat treatment setup with rotary retort furnace and pit type tempering.',
            specs: [
                { label: 'Model Range', value: 'TRE-2A to TRE-6' },
                { label: 'Capacity Range', value: '50-100 KGS TO 500 KGS' },
                { label: 'Hardening Power', value: '24 KWS TO 54 KWS' },
                { label: 'Tempering Power', value: '12 KWS TO 27 KWS' },
                { label: 'Power Source', value: 'Electric' },
                { label: 'Components', value: 'Rotary Retort Furnace, Pit Type Tempering Furnace, Quenching Tank, Geared Motor Agitator, Charge Carrier, Heat Exchanger, Cooling Tower' },
            ],
        },
        {
            id: 'ss-retort',
            name: 'Stainless Steel Retort Furnace',
            category: 'Retort Furnace',
            type: 'retort',
            image: '/sr.jpeg',
            description: 'Robust and durable stainless steel furnace retort for controlled heat treatment.',
            specs: [
                { label: 'Material', value: 'Stainless Steel' },
                { label: 'Max Temperature', value: 'Up to 1100°C' },
                { label: 'Features', value: 'Robust durability, Controlled conditions' },
                { label: 'Application', value: 'Heat treatment under controlled conditions' },
            ],
        },
        {
            id: 'tray-pusher',
            name: 'Tray Pusher Type Furnace',
            category: 'Industrial Furnace',
            type: 'other',
            image: '/bhf.jpeg',
            description: 'Electrogas-fired furnace with highly energy-efficient recuperative burners.',
            specs: [
                { label: 'Capacity Range', value: '500 KGS TO 5 TONS' },
                { label: 'Power Rating', value: '30 KWS TO 200 KWS' },
                { label: 'Power Source', value: 'Electric / Gas' },
                { label: 'Applications', value: 'Hardening, Normalizing, Annealing, Iso-Thermal Annealing, Stress Relieving' },
                { label: 'Features', value: 'Energy-efficient recuperative burners, Substantial operational cost savings' },
            ],
        },
        {
            id: 'normalizing-furnace',
            name: 'Normalizing Furnace',
            category: 'Industrial Furnace',
            type: 'other',
            image: '/nf.jpeg',
            description: 'Stainless steel normalizing furnace for industrial heat treatment applications.',
            specs: [
                { label: 'Material', value: 'Stainless Steel' },
                { label: 'Surface Finishing', value: 'Polished' },
                { label: 'Power Source', value: 'Electric' },
                { label: 'Application', value: 'Industrial Normalizing' },
            ],
        },
        // Industrial Heaters
        {
            id: 'bundle-rod',
            name: 'Bundle Rod Heater',
            category: 'Industrial Heater',
            type: 'heater',
            image: '/brh.jpeg',
            description: 'Industrial bundle rod heater for efficient heating applications.',
            specs: [
                { label: 'Material', value: 'Aluminium, Copper' },
                { label: 'Power Source', value: 'Electric' },
                { label: 'Shape', value: 'Round' },
                { label: 'Application', value: 'Industrial' },
            ],
        },
        {
            id: 'immersion-heater',
            name: 'Immersion Heater',
            category: 'Industrial Heater',
            type: 'heater',
            image: '/ih.jpeg',
            description: 'Polished steel immersion heater for industrial liquid heating.',
            specs: [
                { label: 'Material', value: 'Steel' },
                { label: 'Finishing', value: 'Polished' },
                { label: 'Power Source', value: 'Electric' },
                { label: 'Shape', value: 'Round' },
            ],
        },
        {
            id: 'tubular-heater',
            name: 'Tubular Heater',
            category: 'Industrial Heater',
            type: 'heater',
            image: '/th.jpeg',
            description: 'Polished stainless steel tubular heater for industrial applications.',
            specs: [
                { label: 'Material', value: 'Stainless Steel' },
                { label: 'Finishing', value: 'Polished' },
                { label: 'Power Source', value: 'Electric' },
                { label: 'Application', value: 'Industrial Use' },
            ],
        },
        {
            id: 'radiant-tube',
            name: 'Radiant Tube Heaters',
            category: 'Industrial Heater',
            type: 'heater',
            image: '/rth.jpeg',
            description: 'Specialized insulation materials designed for uniform furnace heating.',
            specs: [
                { label: 'Type', value: 'Radiant Tube' },
                { label: 'Features', value: 'Specialized insulation, Uniform heating, High efficiency' },
                { label: 'Application', value: 'Furnace heating systems' },
            ],
        },
        {
            id: 'heating-elements',
            name: 'Heating Elements',
            category: 'Industrial Heater',
            type: 'heater',
            image: '/ch1.jpeg',
            description: 'Kanthal material heating elements with superior performance and longevity.',
            specs: [
                { label: 'Material', value: 'Kanthal' },
                { label: 'Form', value: 'Strips or Coils' },
                { label: 'Features', value: 'Longevity, Superior heating performance' },
            ],
        },
        // Other Products
        {
            id: 'electrical-control-panel',
            name: 'Electrical Control Panel',
            category: 'Control System',
            type: 'other',
            image: '/ep.jpeg',
            description: 'Advanced electrical control panel for precise furnace operation and monitoring.',
            specs: [
                { label: 'Material', value: 'Stainless Steel' },
                { label: 'Finishing', value: 'Polished' },
                { label: 'Power Source', value: 'Electric' },
                { label: 'Application', value: 'Industrial furnace control and automation' },
                { label: 'Features', value: 'PLC based control, HMI interface, Temperature monitoring' },
            ],
        },
        {
            id: 'quenching-tank',
            name: 'Quenching Tank',
            category: 'Heat Treatment Equipment',
            type: 'other',
            image: '/qt.jpeg',
            description: 'Industrial quenching tank for rapid cooling in heat treatment processes.',
            specs: [
                { label: 'Material', value: 'Mild Steel' },
                { label: 'Power Source', value: 'Electric' },
                { label: 'Frequency', value: '50 Hz' },
                { label: 'Application', value: 'Quenching in heat treatment' },
                { label: 'Country of Origin', value: 'India' },
            ],
        },

    ];

    const filters = [
        { id: 'all', label: 'All Products' },
        { id: 'annealing', label: 'Annealing' },
        { id: 'continuous', label: 'Continuous' },
        { id: 'retort', label: 'Retort' },
        { id: 'heater', label: 'Heaters' },
        { id: 'other', label: 'Others' },
    ];

    const filteredProducts =
        activeFilter === 'all' ? products : products.filter((p) => p.type === activeFilter);

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Hero */}
            <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-3xl">
                        <div className="inline-block px-4 py-2 bg-orange-500/20 border border-orange-500 rounded-full text-sm font-semibold mb-6">
                            Our Products
                        </div>
                        <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                            Industrial Furnaces <span className="gradient-text">&</span><br/>
                            <span className="gradient-text">Heat Treatment Solutions</span>
                        </h1>
                        <p className="text-xl text-gray-300 leading-relaxed">
                            Explore our comprehensive range of industrial furnaces and heat treatment equipment designed for precision, efficiency, and reliability.
                        </p>
                    </div>
                </div>
            </section>

            {/* Filters */}
            <section className="bg-white border-b sticky top-[72px] z-40 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex flex-wrap gap-3">
                        {filters.map((filter) => (
                            <button
                                key={filter.id}
                                onClick={() => setActiveFilter(filter.id)}
                                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                                    activeFilter === filter.id
                                        ? 'gradient-bg text-white shadow-lg scale-105'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:scale-105'
                                }`}
                                data-testid={`filter-${filter.id}`}
                            >
                                {filter.label}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* Products Grid */}
            <section className="section-padding">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {filteredProducts.map((product) => (
                            <div
                                key={product.id}
                                className="bg-white rounded-2xl overflow-hidden shadow-md hover-lift cursor-pointer border border-gray-100"
                                onClick={() => setSelectedProduct(product)}
                                data-testid={`product-${product.id}`}
                            >
                                <div className="relative overflow-hidden h-56">
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                                    />
                                    <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                                        <span className="text-sm font-semibold text-orange-600">{product.category}</span>
                                    </div>
                                </div>
                                <div className="p-6">
                                    <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">{product.name}</h3>
                                    <p className="text-gray-600 mb-4 line-clamp-2">{product.description}</p>
                                    <button className="w-full px-6 py-3 gradient-bg text-white font-semibold rounded-full hover:shadow-xl transition-all duration-300">
                                        View Specifications
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="bg-gradient-to-r from-orange-500 to-yellow-500 py-16">
                <div className="max-w-4xl mx-auto px-4 text-center">
                    <h2 className="text-4xl font-bold text-white mb-4">Need a Custom Solution?</h2>
                    <p className="text-xl text-white/90 mb-8">
                        Tell us your requirements and we&apos;ll design a solution tailored to your needs.
                    </p>
                    <div className="flex flex-wrap justify-center gap-4">
                        <a
                            href="/contact"
                            className="inline-block px-8 py-4 bg-white text-orange-600 font-bold rounded-full hover:shadow-2xl transition-all duration-300"
                        >
                            Request Quote
                        </a>
                        <a
                            href="/catalog.pdf"
                            download="catalog.pdf"
                            className="inline-block px-8 py-4 bg-white/20 backdrop-blur-sm border-2 border-white text-white font-bold rounded-full hover:bg-white/30 transition-all duration-300"
                            data-testid="products-download-catalog-btn"
                        >
                            Download Catalog
                        </a>
                    </div>
                </div>
            </section>

            {/* Product Modal */}
            {selectedProduct && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-md">
                    <div className="bg-white rounded-3xl max-w-5xl w-full max-h-[90vh] overflow-y-auto shadow-2xl animate-fadeIn">
                        {/* Modal Header */}
                        <div className="sticky top-0 bg-gradient-to-r from-orange-500 to-yellow-500 px-8 py-6 flex justify-between items-center">
                            <div>
                                <h2 className="text-3xl font-bold text-white">{selectedProduct.name}</h2>
                                <p className="text-white/90 mt-1">{selectedProduct.category}</p>
                            </div>
                            <button
                                onClick={() => setSelectedProduct(null)}
                                className="p-2 hover:bg-white/20 rounded-full transition-colors"
                                data-testid="modal-close-btn"
                            >
                                <X size={28} className="text-white" />
                            </button>
                        </div>

                        {/* Modal Content */}
                        <div className="p-8">
                            {/* Image */}
                            <div className="mb-8">
                                <img
                                    src={selectedProduct.image}
                                    alt={selectedProduct.name}
                                    className="w-full h-80 object-cover rounded-2xl shadow-lg"
                                />
                            </div>

                            {/* Description */}
                            <div className="mb-8">
                                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                                    <span className="w-1 h-8 bg-gradient-to-b from-orange-500 to-yellow-500 rounded-full"></span>
                                    Product Description
                                </h3>
                                <p className="text-gray-700 leading-relaxed text-lg">{selectedProduct.description}</p>
                            </div>

                            {/* Specifications Table */}
                            <div className="mb-8">
                                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                                    <span className="w-1 h-8 bg-gradient-to-b from-orange-500 to-yellow-500 rounded-full"></span>
                                    Technical Specifications
                                </h3>
                                <div className="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
                                    <table className="w-full">
                                        <tbody className="divide-y divide-gray-200">
                                        {selectedProduct.specs.map((spec, index) => (
                                            <tr
                                                key={index}
                                                className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}
                                            >
                                                <td className="py-4 px-6 font-semibold text-gray-900 w-1/3">
                                                    {spec.label}
                                                </td>
                                                <td className="py-4 px-6 text-gray-700">
                                                    {spec.value}
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* CTA Button */}
                            <div className="flex gap-4">
                                <a
                                    href="/contact"
                                    className="flex-1 px-8 py-4 gradient-bg text-white font-bold rounded-full hover:shadow-2xl transition-all text-center text-lg"
                                >
                                    Request Quote
                                </a>
                                <a
                                    href="/contact"
                                    className="flex-1 px-8 py-4 bg-gray-100 text-gray-900 font-bold rounded-full hover:bg-gray-200 transition-all text-center text-lg"
                                >
                                    Enquire Now
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Products;
